import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';
import messages from './messages';
import DefListColumn from '../DefListColumn';

const TransferPanelJournalDetails = ({ contraAccount, programName, isFirstPartyJournal, journalType }) => (
  <div className={styles.rightPane}>
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.contraAccount} />}
      data={contraAccount}
      dataTestHandle="journalDetails__contraAccount"
    />
    {!isFirstPartyJournal && (
      <DefListColumn
        className={styles.defList}
        title={<FormattedMessage {...messages.program} />}
        data={programName}
        dataTestHandle="journalDetails__programName"
      />
    )}
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.journalType} />}
      data={journalType || '–'}
      dataTestHandle="journalDetails__journalType"
    />
  </div>
);

TransferPanelJournalDetails.propTypes = {
  contraAccount: PropTypes.string.isRequired,
  journalType: PropTypes.string.isRequired,
  programName: PropTypes.string.isRequired,
  isFirstPartyJournal: PropTypes.bool.isRequired,
};

export default TransferPanelJournalDetails;



// WEBPACK FOOTER //
// ./src/components/TransferPanelJournalDetails/index.js